













import CategoryChooserService from '~/services/category/CategoryChooserService'
import CategoryChooserSection from '~/components/car/category/chooser/CategoryChooserSection.vue'
import { defineNuxtComponent } from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  middleware: 'non-expired-manager',
  components: {
    CategoryChooserSection
  },
  async asyncData({ route, $dep, $logger, $i18n }) {
    const categoryChooserService = $dep(CategoryChooserService)
    try {
      const {
        sections: fetchedSections
      } = await categoryChooserService.getClassifiedCreateIndexCategories()

      let sections = fetchedSections
      if (route.params.vtype) {
        const foundSection = fetchedSections.find(
          s => s.type === route.params.vtype
        )
        if (foundSection) {
          foundSection.label = $i18n.t(`new_${route.params.vtype}`) as string
          sections = [foundSection]
        }
      }
      return {
        sections
      }
    } catch (error) {
      $logger.captureError(error)
    }
  },
  data() {
    return {
      sections: []
    }
  }
})
